import { KeyValue } from '@delmonicos/shared-design-system-react/src/components/filter-selector/filter-selector';
import { FilterToggle } from '@delmonicos/shared-design-system-react/src/components/filter-toggle/filter-toggle';
import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  EMSP_INVOICE_TYPES,
  InvoiceType,
} from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/enums/invoice-type.enum';
import { useTranslation } from 'react-i18next';

import {
  InvoiceTypeEnum,
  mapTypeToGenericInvoiceTypes,
} from '@app/feature/invoice/helper/invoice-type.helper';

interface EmspBoInvoiceTypeFilterControllerProps {
  onChange: (itemIds: string[]) => void;
  selectedItemIds: string[];
}

export const EmspBoInvoiceTypeFilterController = ({
  onChange,
  selectedItemIds,
}: EmspBoInvoiceTypeFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const emspInvoiceTypes = EMSP_INVOICE_TYPES.map((type) => ({
    key: InvoiceTypeEnum[type].name,
    value: t(`delmonicos-shared-sdk.enums-invoice-type.${type}`),
  }));

  const additionalBackgroundColor = (item: KeyValue): string => {
    return mapTypeToGenericInvoiceTypes(item.key as InvoiceType).color;
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="column" gap={GapEnum.M}>
      <IconText
        iconName="file-05"
        text={t('delmonicos-shared-sdk.outputs-invoice.type')}
      />
      <FilterToggle
        initialSelectedItemIds={selectedItemIds}
        items={emspInvoiceTypes}
        onChange={onChange}
        additionalBackgroundColor={additionalBackgroundColor}
      />
    </Stack>
  );
};
